import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import ThreeFlatBackground from './ThreeFlatBackground';
import { formatDate } from '../../utils';
import * as THREE from 'three';

/**
 * @category Background
 * @module FlatBackground
 * @property scene
 * @property backgroundUrl
 * @property resetBGBeforeImageLoaded
 * @property imageIntegrity
 * @property enablePan
 * @property type
 * @property onBackgroundReady
 * @property onBackgroundLoaded
 * @return {null}
 */
const FlatBackground = ({
	scene,
	backgroundUrl,
	resetBGBeforeImageLoaded,
	imageIntegrity,
	enablePan = false,
	type,
	onBackgroundReady = () => {},
	onBackgroundLoaded = () => {},
	useSceneBackgroundAsEnvMap = false,
}) => {
	const flatBackground = useRef();

	useEffect(() => {
		console.log(
			'%c >INIT:1 - FlatBackground',
			'color:green',
			backgroundUrl,
		);
		flatBackground.current = new ThreeFlatBackground(enablePan, type);
		if (scene) flatBackground.current.addToScene(scene);
		window.addEventListener('resize', flatBackground.current.setPanArea);

		return () => {
			flatBackground.current.dispose();
			window.removeEventListener(
				'resize',
				flatBackground.current.setPanArea,
			);
		};
	}, []);

	const onLoaded = () => {
		if (useSceneBackgroundAsEnvMap) {
			const textureForEnv = flatBackground.current.sceneObject.material.map.clone();
			textureForEnv.mapping = THREE.EquirectangularReflectionMapping;
			scene.environment = textureForEnv;
		}
		onBackgroundReady();
		onBackgroundLoaded();
	};

	useEffect(() => {
		//sometimes we want to erase previously loaded image texture
		//to avoid flickering
		if (resetBGBeforeImageLoaded) flatBackground.current.resetMaterial();

		const textureUrl = `${backgroundUrl}?key=${
			imageIntegrity
				? imageIntegrity
				: formatDate(new Date(), 'mmddyyyyhh')
		}`
		if (backgroundUrl) {
			flatBackground.current.loadTexture(
				textureUrl,
				onLoaded,
			);
		}
	}, [backgroundUrl]);


	return null;
};

FlatBackground.propTypes = {
	backgroundUrl: PropTypes.string.isRequired,
};

export default FlatBackground;
